import { Box, Paper, Tab, Tabs } from "@mui/material"
import { Link, Outlet, useLocation } from "@tanstack/react-router"
import type { FC } from "react"

import { PageHeader } from "@/components/PageHeader/PageHeader"

const TabsLayout: FC<{
  tabs: { id: string; label: string; path: string }[]
  title: string
}> = ({ tabs, title }) => {
  const location = useLocation()

  const currentTab = tabs.find((tab) => location.pathname.startsWith(tab.path)) || tabs[0]

  return (
    <Paper elevation={0} className='flex min-h-0 grow flex-col overflow-hidden bg-white'>
      <PageHeader title={title} />

      <Box className='flex w-full flex-1 flex-col overflow-y-auto'>
        <Tabs value={currentTab.path} variant='scrollable' scrollButtons='auto'>
          {tabs.map((tab) => (
            <Tab key={tab.id} label={tab.label} value={tab.path} component={Link} to={tab.path} />
          ))}
        </Tabs>

        <Box className='flex min-h-0 grow flex-col py-4'>
          <Outlet />
        </Box>
      </Box>
    </Paper>
  )
}

export default TabsLayout
